import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ElephantLogo from '../components/ElephantLogo';

export default function SignupPage() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirm) {
      setError('Adgangskoderne stemmer ikke overens.');
      return;
    }
    if (password.length < 6) {
      setError('Adgangskoden skal være mindst 6 tegn.');
      return;
    }

    setLoading(true);
    try {
      await register(username, email, password);
      setSuccess('Konto oprettet! Omdirigerer til login...');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Registrering fejlede. Prøv igen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <ElephantLogo size={72} />
          <h1 className="auth-title">Krunk</h1>
          <p className="auth-subtitle">Bliv en del af familien 🐘</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Brugernavn</label>
            <input
              id="username"
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Vælg et brugernavn"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="din@email.dk"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Adgangskode</label>
            <input
              id="password"
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mindst 6 tegn"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm">Bekræft adgangskode</label>
            <input
              id="confirm"
              type="password"
              className="form-input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Gentag din adgangskode"
              required
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Opretter konto...' : 'Opret konto'}
          </button>
        </form>

        <p className="auth-footer">
          Har du allerede en konto?{' '}
          <Link to="/login" className="auth-link">Log ind her</Link>
        </p>
      </div>
    </div>
  );
}
